import * as React from 'react';
/**
 * Хук для создания постоянного RefObject на актуальное значение из аргумента
 *
 * @export
 * @template T
 * @param {T} value
 * @returns
 */

export function useValueRef(value) {
  var ref = React.useRef(value);
  ref.current = value;
  return ref;
}